import React, { Component } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { Redirect } from "react-router";
import PageTitle from "@my-dld/components/PageTitle";
import Strings from "@my-dld/assets/strings";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import TextInputField from "@my-dld/components/Form/TextInputField";
import CheckBoxField from "@my-dld/components/Form/CheckBoxField";
import OwnerCommitteeTermsPopUp from "./OwnerCommitteeTermsPopUp";
import OwnerCommitteeSuccessPopUp from "./OwnerCommitteeSuccessPopUp";
import { CommitteeDoc, OwnerCommitteeDocument, OwnerCommitteeRegister } from "../../ownercommitteeapi/entities";
import { OwnerCommitteeProps, TrackIndex } from "./index";
import { getImagePreview } from "../TabuRequest/BaseTabuRequestForm";
import { hideLoading, showErrorMessage, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { I8N, StringUtil } from "@eres/core";
import { OwnerCommitteeApi } from "../../ownercommitteeapi";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { checkValidationErrorWithMessage } from "../../ownercommitteeapi/api";
import { getEmiratesID } from "@10x/sso";
import { exToMessage } from "@eres/ssoapi/api";
import { JQModal } from "@my-dld/components/Popup/Utils";
import Dropzone from "react-dropzone";
import {
	CommitteeDocTypes,
	getCommitteeDocDate,
	getCommitteeDocMaxSize,
	getCommitteeDocName,
	getCommitteeDocSize,
	getCommitteeDocType
} from "@my-dld/utils/OwnerCommitteeUtils";
import DocumentInputField from "@my-dld/components/Form/DocumentInputField";
import { navigate } from "@my-dld/utils/StoreUtils";

interface Props extends OwnerCommitteeProps {

}

interface State {
	property: AssetCard;
	documents: OwnerCommitteeDocument[];
	isDewaRequire: Boolean;
	dewaNumber?: string;
	requireDocuments: any[];
	formErrors: { [ k: string ]: string | undefined };
	refNumber?: string;
	agree_terms: boolean;
	documents_selected: boolean;
	deletedDoc: boolean;
}

class OwnerCommitteeRegistration extends Component<Props, State> {
	documents: OwnerCommitteeDocument | undefined;

	constructor( props: OwnerCommitteeProps ) {
		super( props );
		this.state = {
			property: props.property,
			formErrors: {},
			documents: props.getDocuments( "documents" ),
			requireDocuments: props.getDocuments( "documents" ),
			isDewaRequire: props.getDocuments( "isDewaRequired" ),
			agree_terms: false,
			documents_selected: true,
			deletedDoc: false,
		};
	}

	render() {
		const { property, formErrors } = this.state;
		const formProps = {
			containerClassName: "form-group mb-4 field-style",
			inputClassName: "form-control",
			holder: this,
		};
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		return <>
			<PageTitle title={ Strings.owner_committee_reg } paths={ [ DashboardBCItem ] }/>
			<div className="row">
				<div className="col-md-12">
					<div className="card">
						<div className="card-header">{ Strings.owner_committee_reg }</div>
						<div className="card-body">
							<div className="mandatory-field-info">
								<small>{ Strings.mandatory_fields_note }</small>
							</div>

							{ this.state.isDewaRequire && <div className="row">
								<div className="col-md-6">
									<div className="form-group">
										<TextInputField
											{ ...formProps }
											placeHolder={ "" }
											id={ "dewaNumber" }
											error={ formErrors.dewaNumber }
											label={ Strings.dewa }
											required={ true }
											maxLength={ 256 }
											onValueChange={ ( value, extra ) => {
												this.setState( { dewaNumber: value } );
											} }
										/>
									</div>
								</div>
							</div> }

							<RenderCommitteeDocuments
								deletedDoc={ this.state.deletedDoc }
								reqDocuments={ this.state.documents }
								onDropRejected={ ( doc, files ) => this.onDropRejected( doc, files ) }
								onDrop={ this.onDrop }
								docsError={ formErrors }
								onDelete={ this.onDelete }/>
							<div className="row">
								<div className="col-md-6">
									<CheckBoxField
										id={ "agree_terms" }
										holder={ this }
										required={ true }
										label={ Strings.i_agree_to + " " }
										labelHREF={ Strings.terms_and_conditions }
										targetHREF={ "#ownerCommitteeTermsAndConditions" }
										error={ formErrors.agree_terms }/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-12 mt-4 mb-4">
					<button
						onClick={ this.uploadCommitteeDocuments } type="button" className="btn btn_1 btn_style1"
						id="ownerCommitteRequestAccept">{ Strings.agree_and_submit }
					</button>
					<button
						onClick={ this.onDisagree } type="button" className="btn btn-grey btn_style1 ms-2 me-2"
						data-bs-dismiss="modal">{ Strings.disagree }</button>
				</div>
				<OwnerCommitteeTermsPopUp/>
				<OwnerCommitteeSuccessPopUp
					refNumber={ this.state.refNumber } onHomePressed={ () => {
					navigate( "/mydld" );
				} }/>
			</div>
		</>;
	}

	validate = () => {
		let isValid: boolean = true;
		const { agree_terms } = this.state;
		const error: { [ k: string ]: string } = {};
		if ( this.state.isDewaRequire && StringUtil.isEmptyStringOrNull( this.state.dewaNumber ) ) {
			error.dewaNumber = Strings.required;
			isValid = false;
		}

		if ( !agree_terms ) {
			error.agree_terms = Strings.required;
			isValid = false;
		}

		for ( const doc of this.state.documents ) {
			if ( doc.isMandatory && ( doc.docs == undefined || doc.docs.length === 0 ) ) {
				error[ doc.name ] = Strings.required;
				isValid = false;
			}
		}

		this.setState( {
			formErrors: error,
		} );

		return isValid;
	};

	private onDropRejected = ( doc: OwnerCommitteeDocument, files: File[] ) => {
		this.setState( {
			deletedDoc: !this.state.deletedDoc,
		} );

		let fileName = files[ 0 ].name;
		let fileTypes = [ ".png", ".jpg", ".jpeg", ".pdf" ];
		let allowed = true;
		for ( const val of fileTypes ) {
			allowed = fileName.includes( val );
		}
		if ( allowed ) {
			showErrorMessage( Strings.file_size_exceed.replace( "~", "" + getCommitteeDocMaxSize( doc ) ) );
		} else {
			showErrorMessage( Strings.wrong_file_type );
		}
	};

	private onDrop = ( doc: OwnerCommitteeDocument, files: File[] ) => {
		files.forEach( ( file ) => {
			if ( file.type.startsWith( "image/" ) || file.type.startsWith( "application/pdf" ) ) {
				this.addFile( doc, file );
			}
		} );
	};

	private onDelete = ( identity: number, index: number ) => {
		this.setState( {
			deletedDoc: !this.state.deletedDoc,
			documents: this.state.documents.map( ( doc: OwnerCommitteeDocument ) => {
				if ( doc.documentId === identity ) {
					if ( doc.docs && doc.docs.length > 0 ) {
						doc.docs.splice( index, 1 );
					}
					return doc;
				}
				return doc;
			} ),
		} );
	};

	private addFile( committeeDocument: OwnerCommitteeDocument, file: File ) {
		const reader = new FileReader();
		reader.onload = () => {
			const binaryStr = reader.result;
			const doc: CommitteeDoc = {
				name: file.name,
				fileName: file.name,
				localData: binaryStr as string,
				type: file.type,
				identity: committeeDocument.documentId as number,
				localFile: file,
				fileSize: file.size
			};
			committeeDocument.docs = [ doc ];
			let error = this.state.formErrors;
			if ( error[ doc.name ] )
				delete error[ doc.name ];

			this.setState( {
				formErrors: error,
				documents: this.state.documents.map( ( doc: OwnerCommitteeDocument ) => {
					return ( committeeDocument.documentId === doc.identity ) ? {
						...doc,
						docs: committeeDocument.docs
					} : doc;
				} ),
			} );
		};
		reader.readAsDataURL( file );
	}

	private onDisagree = () => {
		this.props.onPrevious( TrackIndex.COMMITTEE_STEPS );
	};

	private uploadCommitteeDocuments = () => {
		if ( this.validate() ) {
			showLoading();
			this.uploadDocs( this.state.requireDocuments ).then( ( data ) => {
				this.registerBoardOfMember();
			} ).catch( e => {
				hideLoading();
				showMessage( e );
			} );
		}
	};

	private uploadDocs( reqDocs: OwnerCommitteeDocument[] ): Promise<any> {
		let uploadTasks: Promise<any>[] = [];
		for ( const reqDoc of reqDocs ) {
			if ( reqDoc.docs != undefined ) {
				for ( const doc of reqDoc.docs ) {
					if ( doc.documentId == undefined ) {
						uploadTasks.push( OwnerCommitteeApi.uploadDocument( doc.localFile, this.state.property.propertyId, TabuProfile.getParticipantNumber() as number, reqDoc.documentId ).then( ( response ) => {
							return checkValidationErrorWithMessage( response );
						} ).then( response => {
							if ( response.responseCode === "Success" && response.response ) {
								if ( reqDoc.serverId === undefined ) {
									reqDoc.serverId = response.response.id;
								}

								return Promise.resolve( doc );
							}
							return Promise.resolve( doc );
						} ).catch( reason => {
							return Promise.reject( reason.toString() );
						} ) );
					} else {
						uploadTasks.push( Promise.resolve( doc ) );
					}
				}
			}
		}
		return Promise.all( uploadTasks );
	}

	private registerBoardOfMember() {
		OwnerCommitteeApi.registerBoardMember( this.getPostObject() ).then( ( resp: any ) => {
			hideLoading();
			if ( resp.validationErrorsList && resp.validationErrorsList.length > 0 ) {
				showErrorMessage( OwnerCommitteeApi.getValidationError( resp.validationErrorsList ) );
			} else {
				if ( resp.response.referenceId && resp.response.referenceId.length > 0 ) {
					this.setState( { refNumber: resp.response.referenceId } );
					setTimeout( () => {
						JQModal( "SuccessMsgBoardMember" ).show();
					}, 200 );
				}
			}
		} )
		.catch( e => {
			hideLoading();
			exToMessage( e ).then( message => {
				let key = "newPwd";
				if ( message.src && message.src === "old" ) {
					key = "current";
				}
			} );
		} );
	}

	private getPostObject() {
		let documentIds: number[] = [];
		this.state.requireDocuments.map( ( ( value, index ) => {
			if ( value.serverId && value.serverId > 0 ) {
				documentIds.push( value.serverId );
			}
		} ) );
		let requestObj: OwnerCommitteeRegister = {
			DocumentIds: documentIds,
			EmiratesId: getEmiratesID(),
			OwnerNumber: TabuProfile.getParticipantNumber() as number,
			PropertyId: this.state.property.propertyId,
			requestsource: "DLDWebsite",
			Dewanumber: this.state.dewaNumber,
		};
		return requestObj;
	}
}

export function RenderCommitteeDocuments( props: {
	deletedDoc: boolean,
	reqDocuments: OwnerCommitteeDocument[], onDropRejected: ( ( doc: OwnerCommitteeDocument, files: File[] ) => void ),
	onDrop: ( ( doc: OwnerCommitteeDocument, files: File[] ) => void ), onDelete: ( identity: number, index: number ) => void,
	errorMsg?: string, docsError?: any, showMandatory?: boolean
} ) {
	const { reqDocuments, onDropRejected, onDrop, onDelete, errorMsg, docsError, showMandatory, deletedDoc } = props;
	return ( <div className="row">
		<div className={ "col-12 content-section" }>
			<div className={ "content-section-title" }><span
				className="section-title-span">{ Strings.upload_documents }</span></div>
			{/*<div className={ "mb-3" }><small>{ Strings.tabu_upload_documents_note }</small></div>*/ }
		</div>
		<div className="col-md-12">
			{ errorMsg && <div className="alert alert-danger">{ errorMsg }</div> }
		</div>
		{ reqDocuments.map( ( committeeDoc: OwnerCommitteeDocument, index: number ) => {
			let title = I8N.isRTL() ? committeeDoc.arabicName : committeeDoc.englishName;
			return <div
				key={ "" + index }
				className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 document-upload-owner-committee">
				<Dropzone
					multiple={ false }
					maxSize={ committeeDoc.maxSize }
					onDropRejected={ ( files: File[] ) => {
						onDropRejected( committeeDoc, files );
					} }
					onDrop={ ( files: File[] ) => {
						onDrop( committeeDoc, files );
					} }
					accept={ [ "image/png", "image/jpeg", "application/pdf" ] }>
					{ ( { getRootProps, getInputProps } ) => (
						<DocumentInputField { ...getRootProps() }
						                    key={ "" + deletedDoc }
						                    dropZoneInputProps={ getInputProps() }
						                    required={ committeeDoc.isMandatory }
						                    label={ title }
						                    error={ docsError ? docsError[ committeeDoc.name ] : undefined }
						                    isDocsAdded={ committeeDoc.docs.length !== 0 }/>
					) }
				</Dropzone>
				<div className="mandatory-field-info">
					<div className={ "mb-3" }>
						<small>{ Strings.upload_documents_note.replace( "~", getCommitteeDocMaxSize( committeeDoc ) ) }</small>
					</div>
				</div>
				{ committeeDoc.docs && committeeDoc.docs.length > 0 &&
					<RenderCommitteeUploadDocument
						docs={ committeeDoc.docs }
						onDelete={ ( identity: number, index: number ) => {
							onDelete( identity, index );
						} }/> }
			</div>;
		} )
		}
	</div> );
}


export function RenderCommitteeUploadDocument( props: { docs: CommitteeDoc[], onDelete: ( identity: number, index: number ) => void } ) {
	const { docs, onDelete } = props;
	return <div className={ "mb-2" }>
		{ docs.map( ( committeeDoc: CommitteeDoc, index: number ) => {
			let docType = getCommitteeDocType( committeeDoc );
			let preview = ( docType === CommitteeDocTypes.PDF ) ?
				<i className="far fa-file-pdf"/> : getImagePreview( committeeDoc );
			return <table
				key={ "" + index }
				className="table table-bordered table-condensed table-striped table-responsive-sm upload-table">
				<thead>
				<tr>
					<th>{ Strings.file }</th>
					<th>{ Strings.name }</th>
					<th>{ Strings.size }</th>
					<th>{ Strings.vid_date }</th>
					<th>{ Strings.action }</th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td data-label={ Strings.file }>{ preview }</td>
					<td data-label={ Strings.name }>{ getCommitteeDocName( committeeDoc ) }</td>
					<td data-label={ Strings.size }>{ getCommitteeDocSize( committeeDoc ) + " " + Strings.size_mb }</td>
					<td data-label={ Strings.vid_date }>{ getCommitteeDocDate( committeeDoc ) }</td>
					<td data-label={ Strings.action }>
						<button
							className="btn btn-grey" onClick={ () => {
							onDelete( committeeDoc.identity, index );
						} }><i className="far fa-trash-alt"/>{ Strings.delete }
						</button>
					</td>
				</tr>
				</tbody>
			</table>;
		} )
		}
	</div>;
}

export default OwnerCommitteeRegistration;
